export default {
      id: "arrow-back-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite.svg#arrow-back-usage",
      toString: function () {
        return this.url;
      }
    }